const getContentWrapperClasses = (isSidebarOpen, location) => {
  // Pages without sidebar - these get NO margin
  const noSidebarPages = ["/payment", "/login", "/register", "/forgot-password", "/onboarding-audio-check"];
  const isPublicPage = noSidebarPages.includes(location.pathname);

  // Public pages get full width, no margin
  if (isPublicPage) {
    return "w-full overflow-y-auto min-h-screen";
  }

  // For protected pages with sidebar
  const spaceClass = isSidebarOpen 
    ? "lg:ml-[240px]" 
    : "lg:ml-[80px]";

  return `w-full ${spaceClass} overflow-y-auto min-h-screen transition-all duration-200`;
};

export default getContentWrapperClasses;